/* ═══════════════════════════════════════════════════════════
   MYVICTO — Variant Price Fix v3
   Target: .price__number .money
   ═══════════════════════════════════════════════════════════ */

(function() {
  'use strict';

  if (!window.location.pathname.includes('/products/')) return;

  var handle = window.location.pathname.replace('/products/', '').replace(/\/$/, '').split('?')[0];
  var productData = null;
  var lastVariantId = null;

  fetch('/products/' + handle + '.js')
    .then(function(r) { return r.json(); })
    .then(function(product) {
      productData = product;

      // Only run for products with different prices
      var prices = product.variants.map(function(v) { return v.price; });
      if (!prices.some(function(p) { return p !== prices[0]; })) return;

      // Poll every 200ms for variant changes
      setInterval(function() {
        var variantId = null;

        // Method 1: URL parameter
        var urlVariant = new URLSearchParams(window.location.search).get('variant');
        if (urlVariant) variantId = parseInt(urlVariant);

        // Method 2: Hidden form input
        if (!variantId) {
          var hiddenInput = document.querySelector('form[action*="/cart"] input[name="id"], input[name="id"][type="hidden"]');
          if (hiddenInput) variantId = parseInt(hiddenInput.value);
        }

        // Method 3: Checked radio
        if (!variantId) {
          var checked = document.querySelector('fieldset input[type="radio"]:checked');
          if (checked) variantId = parseInt(checked.value);
        }

        if (variantId && variantId !== lastVariantId) {
          lastVariantId = variantId;
          var variant = productData.variants.find(function(v) { return v.id === variantId; });
          if (variant) {
            var moneyEl = document.querySelector('.price__number .money');
            if (moneyEl) {
              var amount = (variant.price / 100).toFixed(2).replace('.', ',');
              // Preserve currency format from current display
              var current = moneyEl.textContent.trim();
              var currencyPrefix = current.match(/^[€$£]|^CHF\s?|^CA\$/);
              var currencySuffix = current.match(/\s?(EUR|USD|CHF|GBP|CAD)$/);

              if (currencyPrefix) {
                moneyEl.textContent = currencyPrefix[0] + amount;
              } else if (currencySuffix) {
                moneyEl.textContent = amount + ' ' + currencySuffix[1];
              } else {
                moneyEl.textContent = '€' + amount;
              }
            }
          }
        }
      }, 200);
    });
})();